import { motion } from "framer-motion";
import {
  MagnifyingGlass,
  ShieldStar,
  Handshake,
  ChartLineUp,
} from "@phosphor-icons/react";

const COASTAL_IMG =
  "https://static.prod-images.emergentagent.com/jobs/d7525a52-8808-4719-9077-616ff5857b1e/images/b94118a5ddf81e126f199288f4bbbed950049e26e1bc5f8b9a719b7efb3419e5.png";

const STEPS = [
  {
    n: "01",
    icon: MagnifyingGlass,
    title: "Opportunity Screening",
    body: "Every opportunity is validated against structured onboarding standards before reaching the network.",
  },
  {
    n: "02",
    icon: ShieldStar,
    title: "Strategic Matchmaking",
    body: "Investors are paired with verified Goa ventures based on sector, ticket size, and strategic intent.",
  },
  {
    n: "03",
    icon: Handshake,
    title: "Confidential Facilitation",
    body: "Discreet, high-trust introductions between principals — no noise, no intermediaries.",
  },
  {
    n: "04",
    icon: ChartLineUp,
    title: "Exponential Growth",
    body: "The right connection creates exponential value. We make that connection happen.",
  },
];

export const DealFlow = () => {
  return (
    <section
      id="dealflow"
      data-testid="dealflow-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={COASTAL_IMG}
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#02060D] via-[#02060D]/85 to-[#02060D]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="text-xs tracking-[0.3em] uppercase text-[#D1B677] font-medium">
              Deal Flow & Matchmaking
            </span>
          </div>
          <h2 className="font-serif text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1] mb-6">
            The right connection creates{" "}
            <span className="italic text-[#D1B677]">exponential growth.</span>
          </h2>
          <p className="text-[#A1AEBF] text-base leading-relaxed">
            A premium deal ecosystem engineered for high-value collaboration between
            global capital and Goa-based ventures.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/8 border border-white/8">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                data-testid={`dealflow-step-${i}`}
                className="group relative bg-[#050B14] p-10 hover:bg-[#0C5A48]/15 transition-all duration-500"
              >
                <div className="flex items-start justify-between mb-12">
                  <span className="font-serif italic text-[#D1B677]/60 text-2xl">
                    {s.n}
                  </span>
                  <Icon
                    size={28}
                    weight="light"
                    className="text-[#D1B677] group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <h3 className="font-serif text-white text-xl mb-3 leading-snug">
                  {s.title}
                </h3>
                <p className="text-sm text-[#A1AEBF] leading-relaxed">{s.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DealFlow;
